<template>
  <div>
    <q-dialog ref="dialog" @hide="onDialogHide">
      <q-card class="q-dialog-plugin">
        <q-card-section class="row justify-center">
          <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">
            <translate>{{title}}</translate>
          </span>
        </q-card-section>
        <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn v-if="confirm"
            :label="$gettext('LABEL_FALSE')"
            color="grey-7"
            @click="onCancelClick"
            class="q-px-lg"
          />
          <q-btn v-if="confirm"
            :label="$gettext('LABEL_TRUE')"
            color="info"
            @click="onOKClick"
            class="q-px-lg"
          />
          <q-btn v-if="!confirm" :label="$gettext('DIALOGS_OK')" color="info" v-close-popup class="q-px-lg" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { QDialog, Dialog } from 'quasar'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'ClientGeneratorResidueDialog',
  components: {
    QDialog,
    Dialog
  },
  props: {
    title: String,
    confirm: Boolean
  }
})
class ClientGeneratorResidueDialog extends Vue {
  show () {
    this.$refs.dialog.show()
  }

  hide () {
    this.$refs.dialog.hide()
  }

  onDialogHide () {
    this.$emit('hide')
  }

  onOKClick () {
    this.$emit('ok')
    this.hide()
  }

  onCancelClick () {
    this.hide()
  }
}
export default ClientGeneratorResidueDialog
</script>
<style lang="stylus" scoped></style>
